/*
 * Copyright 2019 FedEx
 */
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';
// App Imports
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonReasonCodeComponent } from './components/common-reason-code/common-reason-code.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { TranslatePipe } from './translate-pipe.pipe';
// Service Imports
import { GetAwbDetailsService } from './services/get-awb-details.service';
import { SubmitInfoService } from './services/submit-info.service';
import { LanguageTranslationService } from './services/language-translation.service';
// Prime Ng Imports
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import { AccordionModule } from 'primeng/accordion';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
// for initializing apps with default EN language
export function setUpTranslateFactory(service: LanguageTranslationService): Function {
  return () => service.useLang('en', 'NL');
}

@NgModule({
  declarations: [
    AppComponent,
    CommonReasonCodeComponent,
    ConfirmationComponent,
    TermsAndConditionsComponent,
    TranslatePipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    InputTextModule,
    ButtonModule,
    TooltipModule,
    DialogModule,
    OverlayPanelModule,
    AccordionModule,
    ProgressSpinnerModule,
    InputTextareaModule,
    CheckboxModule,
    HttpClientModule,
    ChipsModule
  ],
  providers: [
    GetAwbDetailsService,
    SubmitInfoService,
    LanguageTranslationService,
    TranslatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: setUpTranslateFactory,
      deps: [LanguageTranslationService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
